export interface TradingDealChannelRef {
  name: string;
  channel: string;
  percentage: number;
}

/** Channel-specific rebate % when configured; otherwise the deal-level default %. */
export function resolveEffectiveTradingDealPercent(
  dealName: string,
  channel: string | null | undefined,
  defaultPercent: number,
  channelOverrides: TradingDealChannelRef[] = []
): number {
  if (!dealName?.trim()) return defaultPercent;

  const normalizedChannel = channel?.trim();
  if (normalizedChannel) {
    const dealKey = dealName.trim().toLowerCase();
    const channelKey = normalizedChannel.toLowerCase();
    const match = channelOverrides.find(
      (row) => row.name.trim().toLowerCase() === dealKey && row.channel.trim().toLowerCase() === channelKey
    );
    if (match != null) return match.percentage;
  }

  return defaultPercent;
}
